<template>
  <div>
	<div class="cgqBox">
		<div class="cgqBoxTil">
			一体防水·高效洗消
		</div>
		<div class="cgqBoxCen">
			一键插拔，即用即插，减少内镜连接及脱机的繁琐步骤
			无需防水盖即可进行洗消，缩减工作流程及时间
		</div>
		<div class="cgqBoxSp">
			<!-- <img src="@/assets/product/page6/sp.png" /> -->
			<video src=""></video>
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.cgqBox{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.cgqBoxTil{
		font-size: 45px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 61px;
	}
	.cgqBoxCen{
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 300;
		color: #000000;
		margin-bottom: 63px;
	}
	.cgqBoxSp{
		width: 100%;
		height: 600px;
		margin-bottom: 38px;
		img{
			width: 100%;
			height: 100%;
		}
		video{
			width: 100%;
			height: 100%;
			border: 2px solid #000;
		}
	}
	.cgqBoxXiao{
		display: flex;
		overflow-x: auto;
		.cgqBoxFor:not(:last-child){
			margin-right: 40px;
		}
		.cgqBoxFor{
			width: 300px;
			
			.cgqBoxForImg{
				width: 70px;
				height: 70px;
				margin-bottom: 40px;
				img{
					width: 70px;
					height: 70px;
					object-fit: cover;
				}
			}
			.cgqBoxForName{
				font-size: 26px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
				margin-bottom: 32px;
			}
			.cgqBoxForCen{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
			}
		}
	}
}
</style>
